import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useColorModeValue,
  useDisclosure,
  Image,
} from "@chakra-ui/react";
import * as React from "react";
import { Logo } from "./Logo";
import { Sidebar } from "./Sidebar";
import { ToggleButton } from "./ToggleButton";
import { CognitoUser } from "amazon-cognito-identity-js";
import { KYDOrganizationUser } from "@common/interfaces/KYDUser";
import { KYDScope } from "@common/interfaces/ICognito";

export const Navbar = ({
  currentUser,
  onOrganizationClick,
  scopes,
}: {
  currentUser: KYDOrganizationUser | null;
  onOrganizationClick: () => void;
  scopes: KYDScope[];
}) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  return (
    <Box
      width="full"
      py="4"
      px={{ base: "4", md: "8" }}
      bg="bg-surface"
      boxShadow={useColorModeValue("sm", "sm-dark")}
    >
      <Flex justify="space-between">
        <Image
          maxW="60px"
          src="https://content.kydlabs.com/system/logoblack.png"
        />
        <ToggleButton
          isOpen={isOpen}
          aria-label="Open Menu"
          onClick={onToggle}
        />
        <Drawer
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          isFullHeight
          preserveScrollBarGap
          // Only disabled for showcase
          trapFocus={false}
        >
          <DrawerOverlay />
          <DrawerContent>
            <Sidebar
              currentUser={currentUser}
              onOrganizationClick={onOrganizationClick}
              scopes={scopes}
            />
          </DrawerContent>
        </Drawer>
      </Flex>
    </Box>
  );
};
